import { render, staticRenderFns } from "./SideNavigationContainer.vue?vue&type=template&id=133ecb3e&"
import script from "./SideNavigationContainer.vue?vue&type=script&lang=js&"
export * from "./SideNavigationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports